"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounstersOrdinalToken__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "theNounstersMaster",
                type: "address",
            },
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
            {
                internalType: "contract IProxyRegistry",
                name: "_proxyRegistry",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "approved",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "ApprovalForAll",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "minter",
                type: "address",
            },
        ],
        name: "MinterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "ordinalSwapAddress",
                type: "bytes",
            },
        ],
        name: "NounsterBurned",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "NounsterCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "nounstersMaster",
                type: "address",
            },
        ],
        name: "NounstersMasterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nounsterId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "ordinalSwapAddress",
                type: "bytes",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getApproved",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
        ],
        name: "isApprovedForAll",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "nounsterId",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "minter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nounstersMaster",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "ownerOf",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxyRegistry",
        outputs: [
            {
                internalType: "contract IProxyRegistry",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        name: "safeTransferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "operator",
                type: "address",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
        ],
        name: "setApprovalForAll",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_minter",
                type: "address",
            },
        ],
        name: "setMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "theNounstersMaster",
                type: "address",
            },
        ],
        name: "setNounstersMaster",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounstersOrdinalToken__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(theNounstersMaster, _minter, _proxyRegistry, overrides) {
        return super.deploy(theNounstersMaster, _minter, _proxyRegistry, overrides || {});
    }
    getDeployTransaction(theNounstersMaster, _minter, _proxyRegistry, overrides) {
        return super.getDeployTransaction(theNounstersMaster, _minter, _proxyRegistry, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounstersOrdinalToken__factory = NounstersOrdinalToken__factory;
NounstersOrdinalToken__factory.bytecode = _bytecode;
NounstersOrdinalToken__factory.abi = _abi;
